export enum Status {
  OPEN = "open",
  CLOSED = "close",
  CLOSED_UNTIL = "closed_until",
  OPEN_24_HOURS = "open_24_hours",
  TEMP_CLOSED = "temporarily_closed",
}
